/* global TradeInValuations */

import React, { Component } from "react"
import PropTypes from "prop-types"
import FiltersBar from "./FiltersBar"
import SuggestedCarsList from "./SuggestedCarsList"
import WishedCarFreetext from "./WishedCarFreetext"
import LoadingPlaceholder from "../../../lib/Components/LoadingPlaceholder"
import Loader from "react-loaders"

export default class StepReplacementCar extends Component {
  constructor(props) {
    super(props)

    const preselectedCarInfo = props.preselectedCarInfo || {}

    this.state = {
      loading: false,
      fetchedCarsList: [],
      // initially used for default FiltersBar values; after that for API calls:
      searchCriteria: {
        min_year: preselectedCarInfo.year || "",
        brand: preselectedCarInfo.brand || "",
        model: preselectedCarInfo.car_model || "",
      },
      wishFreetext: "",
      doesNotWantReplacementCar: false,
      // Used to be able continue without answering
      finishedReplacementStep: false,
      validationFailed: false,
    }
  }

  async componentDidMount() {
    try {
      await this._makeApiRequest(this.props, this.state)
      TradeInValuations.initReplacementCarSearch()
    } catch (err) {
      console.warn(err)
    }
  }

  async componentWillUpdate(nextProps, nextState) {
    if (this.state.searchCriteria !== nextState.searchCriteria) {
      try {
        await this._makeApiRequest(nextProps, nextState)
      } catch (err) {
        console.warn(err)
      }
    }
  }

  async _makeApiRequest(props, state) {
    if (
      !props.showInitialCars &&
      this._isSearchCriteriaEmtpy(state.searchCriteria)
    ) {
      return
    }
    this.setState({ loading: true })
    try {
      const res = await fetch(this._buildApiUrl(props, state))
      const fetchedCarsList = await res.json()

      let finalListOfCars = await fetchedCarsList.cars
      // places the preselected car first in the list to be rendered by SuggestedCarsList
      const preselectedCarObject = await fetchedCarsList.cars.filter(
        (car) => car.id === this._getPreselectedCarId()
      )
      if (preselectedCarObject.length) {
        const _filteredListOfCars = await fetchedCarsList.cars.filter(
          (car) => car.id !== this._getPreselectedCarId()
        )
        finalListOfCars = [...preselectedCarObject, ..._filteredListOfCars]
      }

      this.setState({
        fetchedCarsList: finalListOfCars,
        loading: false,
      })
    } catch (err) {
      console.warn(err)
    }
  }

  _buildSearchQueryString(searchCriteria) {
    let params = []
    if (searchCriteria.min_year) {
      params.push(`s[min_year]=${searchCriteria.min_year}`)
    }
    if (searchCriteria.brand) {
      params.push(`s[brand]=${encodeURIComponent(searchCriteria.brand)}`)
    }
    if (searchCriteria.model) {
      params.push(`s[model_name]=${encodeURIComponent(searchCriteria.model)}`)
    }
    return params.join("&")
  }

  _isSearchCriteriaEmtpy(searchCriteria) {
    return !(
      searchCriteria.min_year ||
      searchCriteria.brand ||
      searchCriteria.model
    )
  }

  _buildApiUrl = (props, state) =>
    `${props.searchApi.baseUrl}/?${props.configParamName}=${encodeURIComponent(
      props.configParamValue
    )}${
      props.departmentId
        ? "&department_id=" + encodeURIComponent(props.departmentId)
        : ""
    }&${this._buildSearchQueryString(state.searchCriteria)}${
      props.sellerCarUrl
        ? "&seller_car_url=" + encodeURIComponent(props.sellerCarUrl)
        : ""
    }`

  _handleFilterChange = (changedFilters) => {
    this.setState({
      ...this.state,
      searchCriteria: {
        ...this.state.searchCriteria,
        ...changedFilters,
      },
    })
  }

  _handleSelectedCarChange = (carId) => {
    const selectedCar = this.state.fetchedCarsList.find(
      (car) => car.id === carId
    )
    this.props.onSelectedCarChange(selectedCar)
  }

  _handleWishTextChange = (e) => {
    this.setState({
      ...this.state,
      wishFreetext: e.target.value,
    })
  }

  _handleNextStep = () => {
    if (
      (this.props.requiredFields === "only_replacement_car" &&
        !this._getPreselectedCarId()) ||
      (this.props.requiredFields === "replacement_car_or_description" &&
        !this._getPreselectedCarId() &&
        !this.state.wishFreetext.length)
    ) {
      this.setState({ validationFailed: true })
    } else {
      this.setState({ finishedReplacementStep: true })
    }
  }

  _getPreselectedCarId() {
    return (this.props.preselectedCarInfo || {}).id
  }

  render() {
    const {
      configParamName,
      configParamValue,
      departmentId,
      creationToken,
      searchCriteriaValues,
      updateFormUrl,
      strings,
    } = this.props

    return (
      <div className="replacement-car">
        <form
          action={updateFormUrl}
          method="post"
          data-remote
          className="center"
        >
          {strings.title && <h2 className="form-heading">{strings.title}</h2>}

          <div>
            <FiltersBar
              // get initial filter values from props:
              values={this.state.searchCriteria}
              // populate dropdowns from props:
              searchCriteria={searchCriteriaValues}
              onFilterChange={(changedFilters) =>
                this._handleFilterChange(changedFilters)
              }
              strings={strings}
            />
            {this.state.loading ? (
              <LoadingPlaceholder
                loader={<Loader type="ball-scale-ripple-multiple" />}
                height={150}
              />
            ) : (
              <SuggestedCarsList
                cars={this.state.fetchedCarsList}
                onClick={(carId) => this._handleSelectedCarChange(carId)}
                selectedCar={this._getPreselectedCarId() || null}
                style={{ marginTop: "25px" }}
                strings={strings}
                fromBookTestDrive={this.props.fromBookTestDrive}
                submitAction={() => {
                  this._handleNextStep()
                }}
              />
            )}

            {!this.props.fromBookTestDrive && (
              <React.Fragment>
                <WishedCarFreetext
                  strings={strings}
                  wishFreetextChange={(e) => this._handleWishTextChange(e)}
                  style={{ marginTop: "25px" }}
                />

                <input
                  type="hidden"
                  required={
                    this.props.requiredFields === "only_replacement_car"
                  }
                  name="trade_in_valuation[car_id]"
                  value={this._getPreselectedCarId()}
                />
                <input
                  type="hidden"
                  name="trade_in_valuation[replacement_car_wishes]"
                  value={this.state.wishFreetext}
                />

                {this.state.validationFailed ? (
                  <p className="validation-error">
                    {this.props.requiredFields ===
                    "replacement_car_or_description"
                      ? strings.validationError.requireCarOrDescription
                      : strings.validationError.requireCar}
                  </p>
                ) : null}

                <div className="control-buttons-container">
                  <button
                    onClick={() => this._handleNextStep()}
                    className="main-cta"
                  >
                    {strings.nextStepButtonText} ›
                  </button>
                </div>
              </React.Fragment>
            )}
          </div>

          {!this.props.fromBookTestDrive && (
            <React.Fragment>
              <input
                type="hidden"
                name="trade_in_valuation[does_not_want_replacement_car]"
                value={this.state.doesNotWantReplacementCar}
              />
              <input
                type="hidden"
                name="finished_replacement_step"
                value={this.state.finishedReplacementStep}
              />
              <input type="hidden" name="_method" value="patch" />
              <input
                type="hidden"
                name={configParamName}
                value={configParamValue}
              />
              {departmentId && (
                <input
                  type="hidden"
                  name="department_id"
                  value={departmentId}
                />
              )}
              <input
                type="hidden"
                name="creation_token"
                value={creationToken}
              />
            </React.Fragment>
          )}
        </form>
      </div>
    )
  }
}

StepReplacementCar.propTypes = {
  configParamName: PropTypes.string,
  configParamValue: PropTypes.string,
  departmentId: PropTypes.string,
  creationToken: PropTypes.string,
  searchApi: PropTypes.object,
  updateFormUrl: PropTypes.string,
  strings: PropTypes.object,
  // used to populate the filter dropdowns:
  searchCriteriaValues: PropTypes.object,
  // used for INITIAL filter dropdown values
  onSelectedCarChange: PropTypes.func.isRequired,
  preselectedCarInfo: PropTypes.object,
  requiredFields: PropTypes.string,
  showInitialCars: PropTypes.bool,
  fromBookTestDrive: PropTypes.bool,
  sellerCarUrl: PropTypes.string,
}
